<template>
  <div>
    <vxe-grid
      size="mini"
      border
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
    >
      <template v-slot:opt="{ row }">
        <el-tooltip
          effect="dark"
          :content="$l('btn_remove') || '移除'"
          placement="top"
        >
          <i class="el-icon-delete tool-btn" @click="remove(row)" />
        </el-tooltip>
      </template>
      <template v-slot:displayName="{ row }">
        {{ row.displayUserName }}
        <el-tag
          v-if="row.v_userStatus"
          size="mini"
          :type="
            row.userStatus === 'N'
              ? 'warning'
              : row.userStatus === 'S'
              ? 'danger'
              : row.userStatus === 'Y'
              ? 'success'
              : ''
          "
        >
          {{ row.v_userStatus }}
        </el-tag>
      </template>
      <template v-slot:empty>
        {{ $l('table_empty_userTable') || '请选择未授权用户' }}
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    roleID: { type: String, default: '' },
  },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          align: 'center',
          fixed: 'left',
          width: 50,
          slots: { default: 'opt' },
        },
        {
          title: this.$l('table_label_userNo') || '用户账号',
          field: 'userNo',
          minWidth: 120,
          align: 'left',
          headerAlign: 'center',
        },
        {
          title: this.$l('table_label_userName') || '用户名称',
          field: 'userName',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
          slots: { default: 'displayName' },
        },
      ],
    }
  },
  computed: {
    height() {
      const height = this.tableHeight - 250
      return height < 500 ? 500 : height
    },
  },
  methods: {
    async remove({ userCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_remove') || '是否移除该用户权限？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .merchantRoleUserDelApi({ roleID: this.roleID, userCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_remove_no') || '移除失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_remove_ok') || '移除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
